import React from 'react';
import DatePicker, {DateObject} from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import Toolbar from 'react-multi-date-picker/plugins/toolbar';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';
import {FiCalendar, FiClock} from 'react-icons/fi';
import 'react-multi-date-picker/styles/layouts/mobile.css';
import './JalaliDateTimePicker.css';

const pad = (value) => String(value).padStart(2, '0');

const toLocalValue = (dateObject) => {
    if (!dateObject) return '';
    const date = dateObject.toDate();
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const createDateObject = (value) => new DateObject({
    date: value ? new Date(value) : new Date(),
    calendar: persian,
    locale: persianFa,
});

export const jalaliPartsFromLocalValue = (value) => {
    const date = createDateObject(value);
    return {jy: date.year, jm: date.month.number, jd: date.day, hour: date.hour, minute: date.minute};
};

export const localValueFromJalaliParts = ({jy, jm, jd, hour, minute}) => toLocalValue(new DateObject({
    calendar: persian,
    locale: persianFa,
    year: Number(jy),
    month: Number(jm),
    day: Number(jd),
    hour: Number(hour),
    minute: Number(minute),
}));

export const formatJalaliDateTime = (value) => {
    if (!value) return 'تعیین نشده';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'نامعتبر';
    return new Intl.DateTimeFormat('fa-IR-u-ca-persian', {dateStyle: 'medium', timeStyle: 'short'}).format(date);
};

function PickerButton({value, openCalendar, label, required, error, disabled}) {
    return <button type="button" disabled={disabled} className={`jalali-modal-trigger ${error ? 'has-error' : ''}`} onClick={openCalendar}>
        <span className="jalali-modal-icon"><FiCalendar/></span>
        <span className="jalali-modal-value"><strong>{label}{required ? ' *' : ''}</strong><small>{value || 'انتخاب تاریخ و ساعت'}</small></span>
        <FiClock/>
    </button>;
}

export default function JalaliDateTimePicker({label, value, onChange, required = false, hint, error, disabled = false, minValue}) {
    const pickerValue = value ? createDateObject(value) : null;
    return <div className="jalali-modal-field">
        <DatePicker
            value={pickerValue}
            onChange={(selected) => onChange(toLocalValue(selected))}
            minDate={minValue ? createDateObject(minValue) : undefined}
            calendar={persian}
            locale={persianFa}
            format="YYYY/MM/DD HH:mm"
            plugins={[
                <TimePicker key="time" position="bottom" hideSeconds/>,
                <Toolbar key="toolbar" position="bottom" sort={['today', 'deselect', 'close']} names={{today: 'امروز', deselect: 'پاک‌کردن', close: 'تأیید و بستن'}}/>,
            ]}
            render={<PickerButton label={label} required={required} error={error} disabled={disabled}/>}
            portal
            calendarPosition="bottom-center"
            className="rmdp-mobile jalali-ready-picker"
            mobileLabels={{OK: 'تأیید', CANCEL: 'انصراف'}}
            editable={false}
            inputMode="none"
            disabled={disabled}
        />
        {(error || hint) && <small className={error ? 'jalali-modal-error' : ''}>{error || hint}</small>}
    </div>;
}
